// Presentation groups only; stored audiences and business recipient rules stay intact.
export const emailAudiences = [['users', 'Users'], ['admin', 'Admin']];
export function emailAudience(value) {
    return value === 'admin' ? 'admin' : 'users';
}
export function emailAudienceNote(key) {
    return '';
}
